/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Milestone } from './Milestone';
import {
    MilestoneFromJSON,
    MilestoneFromJSONTyped,
    MilestoneToJSON,
    instanceOfMilestone,
} from './Milestone';

/**
 * 
 * @export
 * @interface CatalogTaskRequestContent
 */
export interface CatalogTaskRequestContent {
    /**
     * Display title for the catalog entry.
     * @type {string}
     * @memberof CatalogTaskRequestContent
     */
    name: string;
    /**
     * Subtitle shown with the task to provide added context.
     * @type {string}
     * @memberof CatalogTaskRequestContent
     */
    subheading: string;
    /**
     * Instructions visible to educators and students.
     * @type {string}
     * @memberof CatalogTaskRequestContent
     */
    instructions: string;
    /**
     * Optional assets that represent the task itself.
     * @type {Array<string>}
     * @memberof CatalogTaskRequestContent
     */
    assetIds?: Array<string>;
    /**
     * Optional milestones that award partial completion percentages.
     * @type {Array<Milestone>}
     * @memberof CatalogTaskRequestContent
     */
    milestones?: Array<Milestone>;
}


/**
 * Check if a given object implements the CatalogTaskRequestContent interface.
 */
export function instanceOfCatalogTaskRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "subheading" in value;
    isInstance = isInstance && "instructions" in value;
    return isInstance;
}

export function CatalogTaskRequestContentFromJSON(json: any): CatalogTaskRequestContent {
    return CatalogTaskRequestContentFromJSONTyped(json, false);
}

export function CatalogTaskRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogTaskRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'name': json['name'],
        'subheading': json['subheading'],
        'instructions': json['instructions'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(MilestoneFromJSON)),
    };
}

export function CatalogTaskRequestContentToJSON(value?: CatalogTaskRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'name': value.name,
        'subheading': value.subheading,
        'instructions': value.instructions,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(MilestoneToJSON)),
    };
}

